


// export const baseApiUrl = 'http://192.168.11.36:8080/jeecg-boot/api/file'
// export const baseUrl = 'http://192.168.11.36:8080/jeecg-boot/api/intro'

// export const baseApiUrl = 'http://www-test.introtec.cn/file'
// export const baseUrl = 'http://www-test.introtec.cn/api/jeecg-boot/api/intro'


export const baseApiUrl = 'https://www.introtec.cn/file'
export const baseUrl = 'https://www.introtec.cn/api/jeecg-boot/api/intro'